import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Arrow from './Arrow';
import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';
import Slider from '../../../components/Slider/Slider';
import { getScreenWidth, throttle } from '../../../utils';
import { screenSizes } from '../../../styles/variables.style';
import { Section, SlideContent, SliderPlaceholder, Wrapper, Title, Text, ImageWrapper } from './BrandManifesto.style';

class BrandManifesto extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // used for regenerating the slider with different options
      currentScreenSize: getScreenWidth(),
    };

    window.addEventListener('resize', throttle(this.handleScreenResize));
  }

  componentWillMount() {
    const { manifestos } = this.props;
    document.body.style.backgroundColor = manifestos ? manifestos[0].backgroundColor : 'unset';
  }

  componentWillUnmount() {
    document.body.style.transition = 'none';
    document.body.style.backgroundColor = 'white';
  }

  handleScreenResize = () => {
    const newScreenWidth = getScreenWidth();
    const { currentScreenSize } = this.state;
    if (
      (currentScreenSize < screenSizes.tabletL && newScreenWidth >= screenSizes.tabletL) ||
      (currentScreenSize > screenSizes.tabletL && newScreenWidth <= screenSizes.tabletL)
    ) {
      this.setState({
        currentScreenSize: newScreenWidth,
      });
    }
  };

  render() {
    const { locale, manifestos } = this.props;
    const { currentScreenSize } = this.state;
    const isDesktop = currentScreenSize > screenSizes.tabletL;
    document.body.style.backgroundColor = manifestos ? manifestos[0].backgroundColor : 'unset';

    return (
      <Section>
        {manifestos ? (
          <Slider
            auto={5000}
            arrows={isDesktop}
            arrowLeft={isDesktop ? <Arrow side="left" /> : null}
            arrowRight={isDesktop ? <Arrow side="right" /> : null}
            dots
            dotsColor="#333"
            dotsStyle={{ bottom: -50 }}
            keys={manifestos.map(manifesto => manifesto.entryId)}
            options={{
              draggable: !isDesktop,
              duration: isDesktop ? 800 : 400,
              easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
              loop: true,
              perPage: 1,
              onChange: slide => {
                document.body.style.transition = 'background-color 800ms ease-in-out';
                document.body.style.backgroundColor = manifestos[slide].backgroundColor;
              },
            }}
          >
            {manifestos.map(manifesto => (
              <Wrapper key={manifesto.title}>
                {manifesto.url ? (
                  <SlideContent>
                    <Link href={`/${locale}${manifesto.url}`} to={`/${locale}${manifesto.url}`}>
                      <ImageWrapper>
                        <Image src={manifesto.image} options={{ size: [550, 850, 950, 1050] }} />
                      </ImageWrapper>
                      <Title>{manifesto.title}</Title>
                      <Text>{manifesto.description}</Text>
                    </Link>
                  </SlideContent>
                ) : (
                  <SlideContent>
                    <ImageWrapper>
                      <Image src={manifesto.image} options={{ size: [550, 850, 950, 1050] }} />
                    </ImageWrapper>
                    <Title>{manifesto.title}</Title>
                    <Text>{manifesto.description}</Text>
                  </SlideContent>
                )}
              </Wrapper>
            ))}
          </Slider>
        ) : (
          <SliderPlaceholder>
            <Wrapper>
              <ImageWrapper>
                <Placeholder pb="calc(200% / 3)" w="100%" />
              </ImageWrapper>
              <Title>
                <Placeholder h="40px" w="80%" />
              </Title>
              <Text>
                <Placeholder h="100px" w="100%" />
              </Text>
            </Wrapper>
          </SliderPlaceholder>
        )}
      </Section>
    );
  }
}

BrandManifesto.defaultProps = {
  manifestos: undefined,
};

BrandManifesto.propTypes = {
  locale: PropTypes.string.isRequired,
  manifestos: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      image: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        file: PropTypes.shape({
          url: PropTypes.string,
          details: PropTypes.shape({
            size: PropTypes.number,
            image: PropTypes.shape({
              width: PropTypes.number,
              height: PropTypes.number,
            }),
          }),
          fileName: PropTypes.string,
        }),
      }),
    })
  ),
};

export default BrandManifesto;



// WEBPACK FOOTER //
// ./src/pages/HomePage/BrandManifesto/BrandManifesto.js